import {FC} from 'react';

export type TDotTone = 'green' | 'amber' | 'muted';

const DOT_TONES: Record<TDotTone, string> = {
  green: 'bg-emerald-500',
  amber: 'bg-amber-500',
  muted: 'bg-gray-300',
};

export const StatusDot: FC<{tone: TDotTone; label: string}> = ({tone, label}) => (
  <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-gray-500">
    <i className={`h-[7px] w-[7px] rounded-full ${DOT_TONES[tone]}`} />
    {label}
  </span>
);

// Corner dot on a hub step circle; border ring separates it from the icon.
export const CornerDot: FC<{tone: TDotTone}> = ({tone}) => (
  <i className={`absolute -bottom-0.5 -right-0.5 h-[11px] w-[11px] rounded-full border-2 border-white ${DOT_TONES[tone]}`} />
);
